var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.6562 6.5C13.418 6.5 14.0625 7.14453 14.0625 7.90625V14.4688C14.0625 15.2598 13.418 15.875 12.6562 15.875H2.34375C1.55273 15.875 0.9375 15.2598 0.9375 14.4688V7.90625C0.9375 7.14453 1.55273 6.5 2.34375 6.5H3.28125V5.09375C3.28125 2.7793 5.15625 0.875 7.5 0.875C9.84375 0.904297 11.7188 2.80859 11.7188 5.15234V6.5H12.6562ZM4.6875 5.09375V6.5H10.3125V5.09375C10.3125 3.57031 9.02344 2.28125 7.5 2.28125C5.94727 2.28125 4.6875 3.57031 4.6875 5.09375ZM12.6562 14.4688V7.90625H2.34375V14.4688H12.6562Z",
    fill: "#FAFAF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockers);
export default __webpack_public_path__ + "static/media/lockers.9ba2f4a8ca0eeb5cd62d1c042b7f4bee.svg";
export { ForwardRef as ReactComponent };